import apiClient from './apiClient'

const getThreads = (tenant, projectId, onlyThisProject, skip, take, search) => {
  const params = {
    onlyThisProject,
    skip,
    take,
    keyword: search
  }
  return apiClient.get(`/${tenant}/Thread/${projectId}`, { params })
}

const getThreadEmails = (tenant, projectId, threadId, skip, take) => {
  const params = {
    skip,
    take
  }
  return apiClient.get(`/${tenant}/Thread/${projectId}/${threadId}`, { params })
}

const createThread = (tenant, projectId, email) => {
  return apiClient.post(`/${tenant}/Thread/${projectId}`, email)
}

export default {
  getThreads,
  getThreadEmails,
  createThread
}
